import { isPlainObject } from 'lodash';
import { toQueryString } from 'utils/url';

// let errorHandler;
// export function setAjaxErrorHandler(handler) {
//     errorHandler = handler;
// }

// function handleAjaxError(response) {
//     if (errorHandler) {
//         errorHandler(response);
//     }
// }

// export function jsonOrEmpty(body) {
//     return body.text().then((text) => {
//         return text ? JSON.parse(text) : null;
//     });
// }

function getDefaultParams(): Partial<RequestParameters> {
    // const state = getStore().getState();

    return {
        credentials: 'include',
        headers: {
            // 'Bygr-Locale': state.global.currentCulture ? state.global.currentCulture.locale : '',
        },
    };
}

type RequestParameters = RequestInit & {
    query?: object | string;
    json?: boolean;
    body: any;
};
// window.addEventListener('unhandledrejection', (e) => {
//     const reason: Response = e.reason;
//     if (reason && !reason.ok && reason.statusText) {
//         handleAjaxError(e.reason.body);
//     }
// });

export async function request(url: string, params: Partial<RequestParameters> = {}) {
    params = {
        ...getDefaultParams(),
        ...params,
    };

    if (!params.headers) {
        params.headers = {};
    }

    // params.headers["Authorization"] = "Bearer " +

    let queryString = '';
    if (params.query && typeof params.query === 'string') {
        queryString = params.query;
    } else if (params.query && isPlainObject(params.query)) {
        queryString = toQueryString(params.query);
    }

    if (queryString) {
        url += '?' + queryString;
    }

    if (
        isPlainObject(params.body) ||
        Array.isArray(params.body) ||
        (typeof params.body !== 'object' && typeof params.body !== 'function')
        // params.body instanceof FileData
    ) {
        // await Promise.all(getAllPromises(params.body));

        if (params.body) {
            params.body = params.json ? JSON.stringify(params.body) : toQueryString(params.body as object);
        }
    }

    if (params.json) {
        params.headers['Content-Type'] = 'application/json';
    }

    delete params.query;
    delete params.json;

    let promise = fetch(url, params);

    promise = promise.then((response) => {
        if (!response.ok) {
            return Promise.reject(response);
        }

        return response;
    });

    return promise;
}

// function getAllPromises(obj: any): Promise<any>[] {
//     var promises: Promise<any>[] = [];
//     deepTraverse(obj, (val) => {

//         if (val instanceof FileData) {
//             const promise = val.getDataPromise();
//             if (promise) {
//                 promises.push(promise);
//             }
//         }
//     });

//     return promises;
// }